import { LinkOpen } from 'components/package/expedia/enums';
import { LinkState } from 'components/package/expedia/interfaces';

const initialLinkState: LinkState = {
  linkOpen: LinkOpen.NEW_WINDOW,
};

export { initialLinkState };
